<app-modal-filler-atom
  (click)="close()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow md:left-0 md:top-0 md:flex md:h-full md:w-full md:items-center md:justify-center mdMax:mx-auto mdMax:max-h-85-screen mdMax:max-w-screen-sm"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [class.mdMax:bottom-0]="keyboardOffset === 0"
>
  <div
    class="rounded-t-3xl p-5 md:w-2/5 md:max-w-lg md:rounded-3xl md:p-7 kiosk:w-3/4 kiosk:max-w-3/4" [style.backgroundColor]="backgroundColor | contentBuilderColor: '#FFFFFF'"
    [style.z-index]="((index$ | async) ?? 0) + 50"
  >
    @if (!isRewardAddInProgress) {
      @if (currentStep) {
        <app-como-products-selection-step
          [step]="currentStep"
          (goToNextStep)="goToNextStep()"
        ></app-como-products-selection-step>
      }
      <div class="mt-4">
        <app-button-atom
          [label]="'_.cancel' | translate"
          type="light"
          [full]="true"
          (click)="close()"
        ></app-button-atom>
      </div>
    }
    @if (isRewardAddInProgress) {
      <div class="py-4 text-center">
        <img
          src="assets/images/spinner.svg"
          alt=""
          class="mx-auto block"
        />
      </div>
      <div class="mt-4">
        <app-button-atom
          [label]="'_.cancel' | translate"
          type="light"
          [full]="true"
          (click)="close()"
        ></app-button-atom>
      </div>
    }
  </div>
</div>
